export default __webpack_public_path__ + "static/media/pack_tab.d8609772.png";